import '../styles/index.scss';
import { createApp } from 'vue';
import { createWebHashHistory, createRouter } from 'vue-router';
import 'jquery/src/jquery.js'
import '@popperjs/core';
import 'bootstrap' // ← bootstrap!
import Home from './Home.vue';
import Games from './Games.vue';
import Garage from './Garage.vue';
import About from './About.vue';
import Root from './Root.vue';

const routes = [
	{ path: '/', name: 'Home', component: Home},
	{ path: '/garage', name: 'Garage', component: Garage},
	{ path: '/games', name: 'Games', component: Games},
	{ path: '/about', name: 'About', component: About},
];

const router = createRouter({
	history: createWebHashHistory(),
	routes,
});


if (process.env.NODE_ENV === 'development') {
  require('../index.html');
}

createApp(Root).use(router).mount('#vue-app')